"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastsConstants = void 0;
/*
 * Copyright '2021' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
class ToastsConstants {
}
exports.ToastsConstants = ToastsConstants;
ToastsConstants.TOAST_EVENT_NAME = 'toast-show-event';
//# sourceMappingURL=toasts.constants.js.map